import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/bernadette-peters-2022/ads/jerry-seiner.jpg',
      link: 'https://www.jerryseinercadillac.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Jerry Seiner Cadillac',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/springville.jpg',
      link: 'http://www.smofa.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Springville Museum of Art',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/moab.jpg',
      link: 'https://www.discovermoab.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Dicover Moab',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Festival Opera & Musical Theatre',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/werners.jpg',
      link: 'https://wernersmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Werners European',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/rubys-inn.jpg',
      link: 'https://www.rubysinn.com/millsdec22',
      alt: 'Rubys Inn',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/cultural-enterprise.jpg',
      link: 'https://www.williamcall.net/fantasy/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'William Call',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/Challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/Hamilton.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/minky.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Minky Couture',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/RCWilley.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/utah-food-bank.jpg',
      link: 'https://www.utahfoodbank.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Food Bank',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/u-first.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
    {
      image: '/bernadette-peters-2022/ads/bosso.jpg',
      link: 'https://www.bozzo.biz/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Bosso Smart Lighting',
      class: 'webFormat',
    },
  ];

  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
